import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject, Subscription } from 'rxjs';

import { TopbarItem } from './model/topbar-item.model';
import { TopbarItemEventDTO } from './model/dto/TopbarItemEvent.dto';
import { TopbarFilterHandlerService, TopbarFilterSource } from './service/topbar-filter-handler.service';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-topbar-filter',
  templateUrl: './topbar-filter.component.html',
  styleUrls: ['./topbar-filter.component.css']
})
export class TopbarFilterComponent implements OnInit, OnDestroy {

  // private singleFilterSubject = new Subject<TopbarItemEventDTO>();
  private allFiltersSubject   = new Subject<TopbarItemEventDTO[]>();


  public filtros: TopbarItem[];
  subscriptionAddFilters: Subscription;

  constructor(
    private app: AppComponent,
    private topbarFilterHandlerService: TopbarFilterHandlerService
  ) {
    this.filtros = new Array<TopbarItem>();
  }

  ngOnInit() {
    this.subscriptionAddFilters = this.topbarFilterHandlerService
                                      .getAddFilterInTopbarSourceSingleton()
                                      .subscribe((filterSource: TopbarFilterSource) => {
                                        if ( filterSource && filterSource.filtros ) {
                                          this.filtros = filterSource.filtros;
                                        }
                                        else {
                                          this.clearFields();
                                        }

                                        this.topbarFilterHandlerService.setTopbarAllFiltersSubject( this.allFiltersSubject );
                                        // this.topbarFilterHandlerService.setTopbarSingleFilterSubject( this.singleFilterSubject );
                                      });
  }

  ngOnDestroy() {
    if ( this.subscriptionAddFilters ) {
      this.subscriptionAddFilters.unsubscribe();
      this.subscriptionAddFilters = null;
    }

    this.clearFields();
  }

  // public getSingleFilterSubject(): Subject<TopbarItemEventDTO> {
  //   return this.singleFilterSubject;
  // }

  public getAllFiltersSubject(): Subject<TopbarItemEventDTO[]> {
    return this.allFiltersSubject;
  }

  private getAllFiltersDTO(event: any): TopbarItemEventDTO[] {
    const itens: TopbarItemEventDTO[] = [];
    for ( const item of this.filtros ) {
      itens.push({
        event: event,
        topbarItemId: item.getFieldId(),
        topbarItemSelected: item.getItemSelected()
      });
    }

    return itens;
  }


  private clearFields(): void {
    if ( this.filtros ) {
      for ( const o of this.filtros ) {
        o.clear();
      }
    }

    this.filtros = [];
  }

  public fecharELimparFiltros(): void {
    // ESCONDER
    if ( this.app.isTopbarFilterVisible() ) {
      this.app.hideTopbarFilter();

      if ( this.allFiltersSubject ) {
        this.allFiltersSubject.unsubscribe();
      }

      this.clearFields();
    }
  }



  /**
   * GENERIC LISTENERS
   */
  private inputEventHandler(event: any, item: TopbarItem, filtros: TopbarItem[]): void {
    item.dispararDependencia(event, filtros);

    // publica filtro alterado
    // this.singleFilterSubject.next({
    //   topbarItemId: item.getFieldId(),
    //   topbarItemSelected: item.getItemSelected(),
    //   event: event
    // });

    // public todos os filtros da topbar
    this.allFiltersSubject.next(
      this.getAllFiltersDTO(event)
    );
  }

  /**
   * DROPDOWN LISTENERS
   */
  public dropDownOnChange(e: any, item: TopbarItem, filtros: TopbarItem[]): void {
    this.inputEventHandler(e, item, filtros);
  }

  /**
   * AUTOCOMPLETE LISTENERS
   */
   public autocompleteOnSelectItem(e: any, item: TopbarItem, filtros: TopbarItem[]): void {
    this.inputEventHandler(e, item, filtros);
  }

  public autocompleteOnClear(item: TopbarItem, filtros: TopbarItem[]): void {
    item.clear();
    this.inputEventHandler(null, item, filtros);
  }

  /**
   * TEXTO LISTENERS
   */
   public textoOnChange(e: any, item: TopbarItem, filtros: TopbarItem[]): void {
    this.inputEventHandler(e, item, filtros);
  }

  /**
   * DATA LISTENERS
   */
  public dataOnChange(e: any, item: TopbarItem, filtros: TopbarItem[]): void {
    this.inputEventHandler(e, item, filtros);
  }

}
